/**
 * slides 文案数据，对应右侧每张图片的标题与说明
 */
const slideTexts = [
  { t1: 'AI互动', t2: '通过AI大模型，创建的角色将可以进行实时对话、行为互动，根据你的对话和行为，不同性格的角色将有不同的对话、声音和行为风格。' },
  { t1: '创建所爱', t2: '输入姓名、性别、年龄创建一个你想想中的角色，通过定制穿搭、容貌、声音，还原外在。通过文字描述，还原内在。' },
  { t1: '搭建小窝', t2: '可以搭建属于你们共同的小家，装修地板、墙纸，置办家具装点卧室、客厅、厨房等私人空间，进行多种互动和角色扮演。' },
  { t1: '出海探险', t2: '不仅有恬适的生活，岛屿冒险会更加离奇、有趣。提供多个外岛进行探险，收集有趣的道具和宠物，充实岛屿生活。' },
  { t1: '采集制作', t2: '与AI小伙伴一起，在岛屿上培育数十种花卉，进行插花制作。采集食材，烹饪中餐、西餐、茶点、饮料等各种美味。发挥艺术想象力，制作玩偶、绘画、家具定制和房间定制等。' },
  { t1: '岛屿生活', t2: '岛屿生活不孤单，你可以创建多个AI伙伴，一起沙滩采集、抓螃蟹，湖心岛捉迷藏。一起茶餐厅约会，商店购物等，后续多种互动行为持续更新中。' }
];

/**
 * 初始化轮播：绑定事件与自动播放
 */
function initCarousel() {
  const slidesEl = document.getElementById('slides');
  const dots = Array.from(document.querySelectorAll('#carouselDots .dot'));
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  let current = 0;
  let timer = null;

  /**
   * 切换到指定索引的幻灯片并更新左侧文案与指示点
   * @param {number} idx 目标索引
   */
  function goTo(idx) {
    const total = dots.length;
    current = (idx + total) % total;
    slidesEl.style.transform = `translateX(${-current * 100}%)`;
    updateText(current);
    updateDots(current);
  }

  /**
   * 下一张幻灯片
   */
  function next() { goTo(current + 1); }

  /**
   * 上一张幻灯片
   */
  function prev() { goTo(current - 1); }

  /**
   * 更新左侧文案区域内容
   * @param {number} idx 当前索引
   */
  function updateText(idx) {
    const t = slideTexts[idx];
    const tTop = document.getElementById('slideTextTop');
    const tBottom = document.getElementById('slideTextBottom');
    if (tTop && tBottom && t) {
      tTop.textContent = t.t1;
      tBottom.textContent = t.t2;
    }
  }

  /**
   * 更新指示点的激活状态
   * @param {number} idx 当前索引
   */
  function updateDots(idx) {
    dots.forEach((d, i) => {
      if (i === idx) d.classList.add('active');
      else d.classList.remove('active');
    });
  }

  /**
   * 启动自动播放（5秒切换一次）
   */
  function startAuto() { timer = setInterval(next, 5000); }

  /**
   * 停止自动播放
   */
  function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

  // 事件绑定
  prevBtn.addEventListener('click', () => { stopAuto(); prev(); startAuto(); });
  nextBtn.addEventListener('click', () => { stopAuto(); next(); startAuto(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { stopAuto(); goTo(i); startAuto(); }));

  // 初始化
  goTo(0);
  startAuto();
}

// 页面就绪后初始化
document.addEventListener('DOMContentLoaded', initCarousel);

